import React from "react";
import classNames from "classnames";
import { useClasses } from "../";
const styles = (theme) => ({
    block: {
        width: "100%",
        height: "100%",
        borderRadius: "0px",
        backgroundColor: "#fff",
        boxShadow: "rgba(0, 0, 0, 0.4) 0px 0px 4px 0px",
        padding: (props) => typeof props.padding !== "undefined" ? props.padding : 16,
        boxSizing: "border-box",
        "@media print": {
            boxShadow: "none",
        },
    },
});
const Block = (props) => {
    const classes = useClasses(styles, props);
    const { override } = props;
    return (React.createElement("div", { className: classNames([classes.block, override === null || override === void 0 ? void 0 : override.wrapper]) }, props.children));
};
export default Block;
